import type { FullItem } from "@/models/FeedContextProvider";
import type { Feed } from "@/store/types";
import DriverCentricFeedItem from "./driver-centric/DriverCentricFeedItem";

type Props = {
  item: FullItem;
  feed: Feed;
  vListIndex?: number;
  active?: boolean;
  highlightPodcast: boolean;
  setItemNotLoaded?: (value: string) => void;
  preventScroll?: (value: boolean) => void;
  aliasChannelOwnerId?: string;
};

export default function FeedItem(props: Props) {
  return <DriverCentricFeedItem {...props} />;
}
